import router from './router'
import useSliderStore from './store'
import SliderMessages from './localization'

export default {
  router,
  useSliderStore,
  localization: SliderMessages,
}
